'use client';

import { useTranslation } from '@/features/i18n';
import { AssetGrid } from '@/layouts/AssetGrid';
import { CategoryGrid } from '@/layouts/CategoryGrid';
import { useSearch } from '@vimond/features/search';
import { useLocale } from '@vimond/i18n';

export const SearchResults = ({ query = '' }: { query?: string }) => {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const { assets, assetsErrors, categories, categoriesErrors, isLoading } =
    useSearch(query, locale);

  return (
    <div className="mt-10">
      {isLoading && (
        <div className="bg-background-primary flex h-20 items-center justify-center space-x-2">
          <div className="bg-text-highlight h-6 w-6 animate-bounce rounded-full [animation-delay:-0.3s]"></div>
          <div className="bg-text-highlight h-6 w-6 animate-bounce rounded-full [animation-delay:-0.15s]"></div>
          <div className="bg-text-highlight h-6 w-6 animate-bounce rounded-full"></div>
        </div>
      )}

      {categories && categories.length > 0 && (
        <CategoryGrid title={t('search.categories')} categories={categories} />
      )}
      {categoriesErrors && <div>{categoriesErrors.message}</div>}

      {assets && assets.length > 0 && (
        <AssetGrid title={t('search.assets')} assets={assets} />
      )}

      {assets?.length === 0 && categories?.length === 0 && (
        <div className="flex flex-col items-center justify-center space-y-2">
          <div className="text-text-primary text-2xl font-bold">
            {t('search.no-results-found')}
          </div>
          <div className="text-text-secondary">
            {t('search.no-results-found-description')}
          </div>
        </div>
      )}

      {assetsErrors && <div>{assetsErrors.message}</div>}
    </div>
  );
};
